export default "__VITE_ASSET__BP6cr8Nd__"